import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "",
  description:
    "In this principle you can follow the path an acoustic signal takes through the entire auditory system. ",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "text",
            options: {
              formatter: "html",
              scrollbars: true,
              data: `
                <div style="max-width: 93%;margin: 0 auto;">
                  <img src="${config.ASSETS_URL}/02/02/principle/signal-processing-of-sound-by-humans.svg" alt="Signal processing of sound by humans">
                </div>
              `,
            },
          },
          styles: {
            padding: "1% 2%",
          },
        },
      },
    },
  },
};

export default principle;
